import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    featureFlagData: {},
};

const featureFlagSlice = createSlice({
    name: 'featureFlag',
    initialState,
    reducers: {
        setFeatureFlagData(state, { payload }) {
            state.featureFlagData = payload;
        },
        getFeatureFlagData() {},
    },
});

export const featureFlagActions = featureFlagSlice.actions;
export const featureFlagReducer = featureFlagSlice.reducer;
